import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
export default class ControlAniState extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.stateType = this.el.stateType;
        mouseEvent.add_mouse_event(this);
        this.ctrlPic;
    }

    init() {
        this.target.gotoAndStop(0);
        this.ctrlPic = this.itemControl.getItemsByClassName("controlAniStatePic", this);
        this.ctrlPic = this.ctrlPic.filter(child => {
            return child.target == this.target.parent;
        });
        this.ctrlPic = this.ctrlPic[0];
    }

    trigger() {
        self = this;
        switch (self.stateType) {
            case "播放":
                if (this.ctrlPic.target.currentFrame == this.ctrlPic.target.totalFrames) {
                    this.ctrlPic.target.gotoAndStop(0);
                }
                this.ctrlPic.target.play();
                break;
            case "暫停":
                this.ctrlPic.target.stop();
                break;
            case "停止":
                this.ctrlPic.target.stop();
                this.ctrlPic.target.gotoAndStop(0);
                break;
        }
    }
}